<template>
  <div class="cardContainer evaluationHeader">
    <h4>
      {{ $t("label_evaluation_evidencesRequested") }}
    </h4>
    <div class="disclaimer">
      {{
        $t(
          "label_evaluation_requirementEvaluation_evidenceResubmission_disclaimer"
        )
      }}
    </div>
    <div style="margin-top: 20px; margin-bottom: 20px">
      {{
        requirement.evaluation_administrator_node_editRequirement_describeEvidenceRequired
      }}
    </div>

    <template-uploaded-files
      :evaluation-id="evaluationId"
      :evidences="ownedEvidences"
    >
      <template #title>
        {{
          $t("label_evaluation_evidencesRequested_evidencesUploaded_subtitle")
        }}
      </template>
    </template-uploaded-files>

    <template-uploaded-files
      :evaluation-id="evaluationId"
      :evidences="linkedEvidences"
    >
      <template #title>
        {{ $t("label_evaluation_evidencesRequested_evidencesLinked_subtitle") }}
      </template>
    </template-uploaded-files>

    <template-uploaded-files
      :requirement="requirement"
      :evaluation-id="evaluationId"
    />
    <b-btn
      variant="primary"
      :disabled="
        !requirement.evaluation_administrator_node_editRequirement_evidencesReady ||
        requirement.evaluation_administrator_node_editRequirement_evidencesReady ==
          'label_evaluation_evidencesRequested_status_resubmit' ||
        requirement.evaluation_administrator_node_editRequirement_evidencesReady ==
          'label_evaluation_evidencesRequested_status_inProgress'
      "
      @click="showModal = true"
    >
      {{
        $t("label_evaluation_requirementEvaluation_evidenceResubmission_button")
      }}
    </b-btn>

    <evaluation-evidence-resubmission-modal
      :show-modal.sync="showModal"
      :requirement.sync="requirement"
      :account="account"
      :evaluation-id="evaluationId"
      @saveAndForce="saveAndForce"
      @resubmitRequirement="resubmitRequirement"
    />
  </div>
</template>

<script>
import EvaluationEvidenceResubmissionModal from "../organization/EvaluationEvidenceResubmissionModal.vue";
import axios from "axios";

export default {
  name: "EvaluationEvidencesRequested",
  components: { EvaluationEvidenceResubmissionModal },
  props: ["requirement", "evaluationId", "account"],
  data() {
    return {
      ownedEvidences: [],
      linkedEvidences: [],
      showModal: false,
    };
  },
  mounted: async function () {
    this.loadEvidences();
  },
  watch:{
    requirement: function(){
      this.loadEvidences()
    }
  },
  methods: {
    resubmitRequirement(id) {
      this.$emit("resubmitRequirement", id);
    },
    loadEvidences: async function () {
      await axios
        .get(`/Evidences/${this.evaluationId}/${this.requirement.id}`)
        .then((response) => {
          this.ownedEvidences = response.data.owned;
          this.linkedEvidences = response.data.linked;
        });
    },
    saveAndForce() {
      this.$forceUpdate();
      this.$emit("update:requirement", this.requirement);
      this.$emit("saveAndForce");
    },
  },
};
</script>

<style lang="sass" scoped>

.btn-secondary
  margin-top: 20px
</style>
